import $ from 'jquery';
import { v4 as uuidv4 } from 'uuid';
import { fabric } from 'fabric';
import { getAxiosClient } from '~src/api';
import { onErrorShowMessage } from '~src/errors';
import { getState } from '~src/state';
import { b64toBlob } from '~core';
import { cleanBase64 } from '~src/utils';
import { getMetadata } from '~loader/loader-utils';
import { modifyState } from '../../state';
import { trackEvent } from '~src/tracking';
import {
  startAiLoader,
  stopAiLoader,
  showAiSuccessMessage,
  sleep,
  AI_FEATURE_LOADING_MESSAGES,
} from '~core/aiLoader';
import { handleTabImagesAI } from '~src/sidebar/index';
import { applyMagicEraser } from './applyMagicEraser';
import { postEncryptedGiottoApiPayload } from '~core/aiBackground/promptEncryption';

const isMagicEraserResultReady = (response) =>
  response.status === 200 && Boolean(response.data?.imageUrl);

export const requestMagicEraser = async () => {
  const startTime = performance.now();

  startAiLoader(
    AI_FEATURE_LOADING_MESSAGES.MAGIC_ERASER,
    '✨ Pennello Correttivo'
  );

  let mask = window.magicEraserManipulationCanvas.toDataURL({
    format: 'jpg',
    multiplier: 1,
    quality: 0.1,
    enableRetinaScaling: false,
  });

  let image = window.magicEraserDrawingCanvas
    .getObjects()
    .find((obj) => obj.type === 'image');

  const maskFilename = `magicEraserMask-${uuidv4()}.png`;
  const maskBlob = b64toBlob(cleanBase64(mask).base64, 'image/png');

  const attachmentsUploader = getState('uploader.magiceraser');

  attachmentsUploader.addFile({
    name: maskFilename,
    type: maskBlob.type,
    data: maskBlob,
  });

  const uploadResponse = await attachmentsUploader.upload();
  attachmentsUploader.cancelAll();
  const maskUrl = `${process.env.EDGE_RESIZER}${
    new URL(uploadResponse.successful[0].uploadURL).pathname
  }`;

  const imageUrl =
    image.getSrc() || image._element.src || image._element.currentSrc;

  let maxAttempts = 200;

  const httpClient = await getAxiosClient();
  const httpClientWithRetries = await getAxiosClient(true, maxAttempts);

  const metadata = getMetadata();

  const payload = {
    maskUrl,
    imageUrl,
    canvasId: window.editorLoader.canvasId,
    notes: JSON.stringify(
      Object.assign({}, metadata, {
        canvasId: window.editorLoader.canvasId,
      })
    ),
  };

  const servizio = getState('selected.servizio');

  if (servizio && servizio.objectId) {
    payload.servizioId = servizio.objectId;
  }

  let queueResponse;
  let response;

  // const maxAttempts = 100;
  // const httpClient = await getAxiosClient();
  // const httpClientWithRetries = await getAxiosClient(true, maxAttempts);

  try {
    queueResponse = await postEncryptedGiottoApiPayload(
      httpClient,
      `${process.env.GIOTTO_API_URL}/magic-brush`,
      payload
    );
  } catch (err) {
    console.error(err);
    stopAiLoader();
    return onErrorShowMessage();
  }

  await sleep(1000);

  try {
    response = await httpClientWithRetries.get(
      `${process.env.GIOTTO_API_URL}/magic-brush?requestId=${queueResponse.data.requestId}`,
      {
        'axios-retry': {
          validateResponse: isMagicEraserResultReady,
        },
      }
    );
  } catch (err) {
    console.error(err);
    stopAiLoader();
    return onErrorShowMessage();
  }

  const url = response.data.imageUrl;

  new fabric.Image.fromURL(
    url,
    async (img) => {
      const cursor = window.magicEraserDrawingCanvas
        .getObjects()
        .find((obj) => obj.type === 'circle');
      const objectsToRemove1 = window.magicEraserDrawingCanvas
        .getObjects()
        .filter((obj) => obj !== cursor); // only saving the cursor
      for (const obj of objectsToRemove1) {
        window.magicEraserDrawingCanvas.remove(obj);
      }

      const objectsToRemove2 = window.magicEraserManipulationCanvas
        .getObjects()
        .filter((obj) => obj.type !== 'rect'); // only saving the black rect
      for (const obj of objectsToRemove2) {
        window.magicEraserManipulationCanvas.remove(obj);
      }

      img.set({
        selectable: false,
        evented: false,
        crossOrigin: 'anonymous',
      });
      img.scaleToHeight(window.magicEraserDrawingCanvas.height);
      window.magicEraserDrawingCanvas.add(img);
      window.magicEraserDrawingCanvas.sendToBack(img);
      window.magicEraserDrawingCanvas.centerObject(img);
      window.magicEraserDrawingCanvas.requestRenderAll();
      modifyState('magicEraserResultImageUrl', url);
      modifyState('magicEraserMaskUrl', maskUrl);
      $('#editor-menu-run-magic-eraser').attr('disabled', true);
      // $('#editor-menu-apply-magic-eraser').attr('disabled', false); // Deprecated

      stopAiLoader();

      // Refresh AI credits display
      handleTabImagesAI();

      // Show success message
      showAiSuccessMessage(
        'Correzione Completata',
        'Gli elementi sono stati rimossi con successo!'
      );

      trackEvent('AI MagicEraser', {
        success: true,
        time_taken: parseInt(performance.now() - startTime, 10),
      });

      // Auto-apply the magic eraser result directly
      await applyMagicEraser();
    },
    { crossOrigin: 'anonymous' }
  );
};
